import { GetCustomerCopyFunc } from '@lyrahealth-inc/shared-app-logic/src/models/customer/Customer'

export const purestorage: GetCustomerCopyFunc = () => {
  return {
    displaySessionLimit: false,
  }
}
